"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/alt-text */

/**
 * Wrap your `<img>` or `<svg>` elements with this to ensure
 * the correct styles are applied,
 */


var GlobalHeaderLogoImage = function (_React$Component) {
  _inherits(GlobalHeaderLogoImage, _React$Component);

  function GlobalHeaderLogoImage() {
    _classCallCheck(this, GlobalHeaderLogoImage);

    return _possibleConstructorReturn(this, (GlobalHeaderLogoImage.__proto__ || Object.getPrototypeOf(GlobalHeaderLogoImage)).apply(this, arguments));
  }

  _createClass(GlobalHeaderLogoImage, [{
    key: "render",
    value: function render() {
      return _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          className: (0, _classnames2.default)("cdk-global-header__logo-image", child.props.className)
        });
      });
    }
  }]);

  return GlobalHeaderLogoImage;
}(_react2.default.Component);

exports.default = GlobalHeaderLogoImage;